
import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { routeLinks } from './routeLinks'
import ProtectedRoute from '../Features/Auth/components/ProtectedRoute'
import PasswordChangeGuard from '../Features/Auth/components/PasswordChangeGuard';

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={routeLinks.find((r) => r.path === '/login')?.element} />
      <Route
        path="/auth/verify-email"
        element={routeLinks.find((r) => r.path.includes('verify-email'))?.element}
      />

      {/* Protected routes - requires authentication */}
      <Route element={<ProtectedRoute />}>
        {/* Change password route - accessible with auth but bypasses PasswordChangeGuard */}
        <Route
          path="/change-password"
          element={routeLinks.find((r) => r.path === '/change-password')?.element}
        />

        {/* All other protected routes - requires auth AND no password change flag */}
        <Route element={<PasswordChangeGuard />}>
          {/* Main app with layout */}
          {routeLinks
            .filter((r) => r.path === '/')
            .map((link) => (
              <Route key={link.path} path={link.path} element={link.element}>
                {link.children?.map((child) => (
                  <Route key={child.path} path={child.path} element={child.element} />
                ))}
              </Route>
            ))}
        </Route>
      </Route>
    </Routes>
  );
};

export default AppRoutes